import React from 'react';
import { useNavigate } from 'react-router-dom';
import './Lead_head.css';

const GenealogyHead = () => {
    const navigate = useNavigate();

    const handleDirectGenealogy = () => {
        navigate('/Sidebar/Leadtran');
    };

    const handleAutopoolGenealogy = () => {
        navigate('/Sidebar/Distribution');
    };

    return (
        <div className="genealogy-container">
            <h1 className="genealogy-title">Lead Management Application</h1>



            <div className="genealogy-buttons">
                <button
                    className="genealogy-button direct-genealogy"
                    onClick={handleDirectGenealogy}
                >
                  Existing  Lead Transfer
                </button>

                <button
                    className="genealogy-button autopool-genealogy"
                    onClick={handleAutopoolGenealogy}
                >
                    New Enquiry Leads
                </button>
            </div>

            <div className="genealogy-info">
                <div className="genealogy-card">
                    <h3 className="genealogy-card-title">🔁 Existing Lead Transfer</h3>
                    <ul className="genealogy-card-list">
                        <li>Leads are transferred by the team head from one team member to another.</li>
                        <li>Used when an team member can’t handle leads due to holidays, workload, or other reasons.</li>
                        <li>Ensures leads are managed without interruption.</li>
                        <li>Transfers are controlled and tracked by the team head.</li>
                    </ul>
                </div>

                <div className="genealogy-card">
                    <h3 className="genealogy-card-title">📤 New Enquiry Leads Distribution</h3>
                    <ul className="genealogy-card-list">
                        <li>New enquiry leads are assigned by the team head to team members.</li>
                        <li>Distribution is manual, based on team member availability and workload.</li>
                        <li>Helps maintain fair and balanced lead assignments.</li>
                        <li>Leads are distributed quickly to start follow-up immediately.</li>
                    </ul>
                </div>
            </div>



        </div>
    );
};

export default GenealogyHead;
